import React, { useState, useContext, useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { CardContent, Grid, Button, TextField, MenuItem, Typography, Card, Box, Tooltip, Stack, Autocomplete } from '@mui/material';
import { DataGrid, esES, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid';
import FormUsuario from '../components/usuarios/FormUsuario';
import { RootStoreContext } from "../app/store/root";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { ModalComponent } from "../app/common/ModalComponent";
import RenderStatus from "../app/common/RenderStatus";
import { Catalogos } from "../app/util/catalogos"
import DeleteDialog from "../app/common/DeleteDialog";
import { Acciones } from "../app/util/permisos"
import { account } from '../shared/Utils';
import { Menu } from '../app/util/permisos';
import { Link, useNavigate } from "react-router-dom";
import { EnumPerfiles, EnumStatusShipment } from '../shared/Enumerables';
import DialogComponent from "../app/common/DialogComponent";
import { AutoAwesome } from '@mui/icons-material';
import { mode } from 'crypto-js';
import { EnumCatalogosEncabezado, EnumCatalogoEstatusString } from "../shared/Enumerables";

const UsersPage = () => {
    const navigate = useNavigate();
    const rootStore = useContext(RootStoreContext);

    const {
        entities,
        getAll,
        getAllByFilter,
        activeOrInactive,
        deleteUsuario,
        updatePerfil
    } = rootStore.usuarioStore

    const {
        entities: perfilesList,
        getAll: getAllPerfiles
    } = rootStore.perfilStore

    const {
        entities: proveedoresList,
        getAll: getAllProveedor
    } = rootStore.proveedorStore

    const {
        getValoresCatalogo,
    } = rootStore.catalogosStore

    const [perfilesFiltro, setPerfilesFiltro] = useState([])
    const [proveedoresFiltro, setProveedoresFiltro] = useState([])
    const [estatusFiltro, setEstatusFiltro] = useState([])
    const [estatus, setEstatus] = useState([])

    useEffect(() => {
        document.title='Lilofy | Usuarios';
        if (!account.getPermisosUsuario().some(a => a.clavePermiso == Menu.Usuarios && a.tienePermiso)) {
            navigate("/Usuarios/AccessDenied");
        } else {
            setPermisosUsuario(account.getPermisosUsuario())
            loadDataPage()
        }
    }, [])

    useEffect(() => {
        if (perfilesList && perfilesList?.length > 0) {
            let newPerfiles = [{ idPerfil: -1, nombrePerfil: "Todos", descripcionPerfil: '', esInterno: false }].concat(perfilesList)
            setPerfilesFiltro(newPerfiles);
        }
    }, [perfilesList]);

    useEffect(() => {
        if (proveedoresList && proveedoresList?.length > 0) {
            let newProveedores = [{ id: "-1", proveedores: "Todos" }].concat(proveedoresList.map(a => { return { id: a.id, proveedores: a.proveedores } }))
            setProveedoresFiltro(newProveedores);
        }
    }, [proveedoresList]);

    const loadDataPage = async () => {
        rootStore.logisticBackdropStore.openLoading()
        await getAll()
        await getAllPerfiles()
        await getAllProveedor()
        let estatus = await getValoresCatalogo(EnumCatalogosEncabezado.Estatus)
        if (estatus != null) {
            setEstatus(estatus.filter(a => a.valor.toUpperCase() != EnumCatalogoEstatusString.Eliminado))
            estatus = [{ id: -1, valor: "Todos" }].concat(estatus.filter(a => a.valor.toUpperCase() != EnumCatalogoEstatusString.Eliminado))
            setEstatusFiltro(estatus)
        }
        setCargaInicial(true)
        rootStore.logisticBackdropStore.closeLoading()
    }

    const initialFilter = {
        IdPerfil: undefined,
        IdProveedor: undefined,
        IdEstatus: undefined
    };

    const [cargaInicial, setCargaInicial] = useState(false)
    const [permisosUsuario, setPermisosUsuario] = useState([])
    const { setRowDelete } = rootStore.deleteStore;
    const [modelFilter, setModelFilter] = useState(initialFilter);
    const [entitiesActivos, setEntitiesActivos] = useState([]);
    const [idUsuario, setId] = useState(undefined);
    const [model, setModel] = useState(undefined);
    const [openModal, setOpenModal] = useState(null);

    const [pageSize, setPageSize] = React.useState(5);
    const [openDialogUsers, setOpenDialog] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const handleClick = (event) => { setAnchorEl(event.currentTarget) };
    useState(false);

    useEffect(() => {
        setEntitiesActivos(entities.filter(a => a.idEstatus != Catalogos.Estatus.Eliminado))
        if (entities.filter(a => a.idEstatus != Catalogos.Estatus.Eliminado).length == 0 && cargaInicial) {
            rootStore.alertStore.alertError('No se encontraron resultados')
        }
    }, [entities])

    const clearFormModel = () => {
        setId(undefined);
        setModel(undefined);
        setOpenModal(false);
    }

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenModal(false)
    }

    const closeDialog = () => {
        setOpenDialog(null);
    }

    const clickBuscarUsuarios = (event) => {
        event.preventDefault()
        const initialFilter = {
            IdPerfil: modelFilter.IdPerfil < 0 ? null : modelFilter.IdPerfil,
            IdProveedor: modelFilter.IdProveedor < 0 ? null : modelFilter.IdProveedor,
            IdEstatus: modelFilter.IdEstatus < 0 ? null : modelFilter.IdEstatus
        }
        getAllByFilter(initialFilter)
    }

    const clearDeleteModel = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setId(undefined);
        setRowDelete(undefined);
        setShowDeleteDialog(false);
    }

    const setValueFilter = (key, value) => {
        setModelFilter({ ...modelFilter, ...{ [key]: value } });
    }

    const onFinishFormulario = (resp) => {
        if (resp) {
            if (idUsuario == undefined || idUsuario == null) {
                rootStore.alertStore.alertCreateSuccess();
            } else {
                rootStore.alertStore.alertUpdateSuccess();
            }
            clearFormModel()
            getAll()
        }
    }

    /* Methods */
    const updateUsuario = (params) => {
        const row = toJS(params.row);
        if (row && Object.keys(row).length > 0) {
            setId(row.idUsuario);
            setModel({
                Nombre: row.nombre,
                ApellidoPaterno: row.apellidoPaterno,
                ApellidoMaterno: row.apellidoMaterno,
                Correo: row.correo,
                Celular: row.celular,
                IdPerfil: row.idPerfil,
                IdProveedor: row.idProveedor,
                Contraseña: row.contraseña,
                Contraseña2: row.contraseña,
            });
            setOpenModal(true);
        }
    };

    const _activeOrInactive = async (idUsuario, idEstatus, row) => {
        rootStore.logisticBackdropStore.openLoading()
        await activeOrInactive(idUsuario, idEstatus).then((resp) => {
            if (resp.success) {
                rootStore.alertStore.alertCreateSuccess("Guardado exitosamente");
                row.row.idEstatus = idEstatus
                rootStore.logisticBackdropStore.closeLoading()
            } else {
                if (resp.responseMessage) rootStore.alertStore.alertError(resp.responseMessage);
                else rootStore.alertStore.alertError("Error en el proceso");
                rootStore.logisticBackdropStore.closeLoading()
            }
        }, (err) => { });
    }

    const _deleteUsuario = async () => {
        await deleteUsuario(idUsuario).then((resp) => {
            if (resp.success) {
                rootStore.alertStore.alertCreateSuccess("Eliminado exitosamente")
                clearDeleteModel()
                getAll()
            } else {
                if (resp.responseMessage) rootStore.alertStore.alertError(resp.responseMessage);
                else rootStore.alertStore.alertError("Error en el proceso");
            }
        }, (err) => { });
    }

    const [mensajeCambioEstatus, setMensajeCambioEstatus] = useState('')
    const [showCambioEstatus, setShowCambioEstatus] = useState(false)
    const [rowCambioEstatus, setRowCambioEstatus] = useState(null)

    const handleChangeRol = (event, row) => {
        if (event && row) {
            let message = `¿Esta seguro que desea cambiar el perfil del usuario ${[row.nombre, row.apellidoPaterno, row.apellidoMaternorow].join(' ')} de ${perfilesList.find(b => b.idPerfil == row.idPerfil)?.nombrePerfil ?? ''} a ${perfilesList.find(b => b.idPerfil == event.target.value)?.nombrePerfil ?? ''}`
            setRowCambioEstatus({ idUsuario: row.idUsuario, idPerfil: event.target.value })
            setMensajeCambioEstatus(message)
            setShowCambioEstatus(true);
        }
    };

    const confirmarCambioEstatus = async () => {
        rootStore.logisticBackdropStore.openLoading()
        if (rowCambioEstatus != null) {
            var resp = await updatePerfil(rowCambioEstatus.idUsuario, rowCambioEstatus.idPerfil)
            if (resp.data == true) {
                setEntitiesActivos(entitiesActivos.map(a => {
                    return {
                        ...a,
                        idPerfil: (a.idUsuario == rowCambioEstatus.idUsuario) ? rowCambioEstatus.idPerfil : a.idPerfil
                    }
                }))
                rootStore.alertStore.alertSuccess('Guardado exitosamente')
            }
        }
        rootStore.logisticBackdropStore.closeLoading()
    }

    const columns = [
        {
            field: "nombre",
            valueGetter: (data) => { return [data.row.nombre, data.row.apellidoPaterno, data.row.apellidoMaterno].join(' ') },
            headerName: 'Nombre',
            minWidth: 150,
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">Nombre</span>
              ),
        },
        {
            field: 'correo',
            headerName: 'Correo',
            minWidth: 200,
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">Correo</span>
              ),
        },
        {
            field: 'celular',
            headerName: 'Teléfono',
            sortable: false,
            minWidth: 150,
            flex: 0.5,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">Teléfono</span>
              ),
        },
        {
            field: 'proveedor',
            headerName: 'Proveedor',
            minWidth: 150,
            flex: 0.5,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">Proveedor</span>
              ),
        },
        {
            field: 'rol',
            headerName: 'Perfil',
            sortable: false,
            renderCell: (row) => (
                <Box
                    noValidate
                    component="form"
                    className='p-2'
                    sx={{ display: 'flex', width: '100%' }}>
                    {/* <Autocomplete
                        size="small"
                        margin="normal"
                        fullWidth
                        id="selectRol"
                        label="Perfil"
                        name="selectRol"
                        disabled={!permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) || !perfilesList.find(b => b.idPerfil == row.row.idPerfil)?.esInterno}
                        onChange={(event, newValue) => {
                            handleChangeRol(event, newValue?.id ?? null, row.row)
                        }}
                        options={perfilesList.filter(a => a.esInterno == perfilesList.find(b => b.idPerfil == row.row.idPerfil)?.esInterno).map(a => { return { label: a.nombrePerfil, id: a.idPerfil } })}
                        renderInput={(params) => <TextField {...params} label="Perfil" />}
                        
                    >
                    </Autocomplete> */}
                    <TextField
                        size="small"
                        margin="normal"
                        select
                        required
                        fullWidth
                        id="selectRol"
                        label="Perfil"
                        name="selectRol"
                        disabled={!permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) || !perfilesList.find(b => b.idPerfil == row.row.idPerfil)?.esInterno}
                        onChange={(e) => { handleChangeRol(e, row.row) }}
                        value={row.row.idPerfil}
                    >
                        {perfilesList.filter(a => a.esInterno == perfilesList.find(b => b.idPerfil == row.row.idPerfil)?.esInterno).map((perfil) => (
                            <MenuItem id={perfil.idPerfil} value={perfil.idPerfil}>{perfil.nombrePerfil}</MenuItem>
                        ))}
                    </TextField>
                </Box >
            ),
            minWidth: 200,
            flex: 0.5,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">Perfil</span>
              ),
        },
        {
            field: "estatus",
            headerName: "Estatus",
            sortable: true,
            renderCell: (row) => (
                <RenderStatus
                    Row={row}
                    FieldName="Usuario"
                    NameRow={[row.row.nombre, row.row.apellidoPaterno, row.row.apellidoMaterno].join(' ')}
                    MessageWhenInactive=""
                    PermisoEditar={permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_estatus_usuario && a.tienePermiso)}
                    OnFinish={(idEstatus) => {
                        _activeOrInactive(row.row.idUsuario, idEstatus, row);
                    }}
                />
            ),
            minWidth: 200,
            flex: 0.5,
            headerClassName: "tableHeaders",
            renderHeader: () => (
                <span className="headerTable">Estatus</span>
              ),
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            headerClassName: 'tableHeaders',
            getActions: (params) => [
                <Tooltip title="Editar" placement="top">
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Editar"
                        color='primary.main'
                        hidden={!permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_usuario && a.tienePermiso)}
                        onClick={() => updateUsuario(params)}
                        renderCell={() => updateUsuario(params)}
                    />
                </Tooltip>,
                <Tooltip title="Eliminar" placement="top">
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Eliminar"
                        color='primary.main'
                        hidden={!permisosUsuario.some(a => a.clavePermiso == Acciones.Eliminar_usuario && a.tienePermiso)}
                        onClick={() => {
                            const row = toJS(params.row);
                            if (row && Object.keys(row).length > 0) {
                                setRowDelete({
                                    NameRow: [row.nombre, row.apellidoPaterno, row.apellidoMaterno].join(' '),
                                    MessageWhenDelete: ``,
                                });
                                setId(row.idUsuario);
                                setShowDeleteDialog(true);
                            }
                        }}
                    />
                </Tooltip>
            ],
        },
    ];
    return (
        <>
            <div className="main-container">
                <div className='mb-2'>
                    <Typography color='primary' variant='h4'>
                        <PersonIcon sx={{ marginRight: 2 }} fontSize="large" />
                        Usuarios
                    </Typography>
                </div>
                <Card className='card'>
                    <CardContent>
                        <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                            <Grid item >
                                {permisosUsuario.some(a => a.clavePermiso == Acciones.Alta_usuario && a.tienePermiso) &&
                                    <Button
                                        onClick={() => {
                                            setOpenModal(true);
                                            setModel(undefined);
                                        }}

                                        variant="contained">
                                        Nuevo Usuario
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} direction={'row'} alignItems={"center"} mb={1}>
                            <Grid item xs="12" sm="6" md="3" lg="2">
                                <Autocomplete
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    id="filterRol"
                                    label="Perfil"
                                    name="filterRol"
                                    onChange={(event, newValue) => {
                                        setValueFilter('IdPerfil', newValue?.id ?? null)
                                    }}
                                    options={perfilesFiltro.filter(a => a.nombrePerfil?.toUpperCase() != EnumPerfiles.Proveedor).map(a => { return { label: a.nombrePerfil, id: a.idPerfil } })}
                                    renderInput={(params) => <TextField {...params} label="Perfil" />}
                                >
                                </Autocomplete>
                            </Grid>
                            <Grid item xs="12" sm="6" md="3" lg="3">
                                <Autocomplete
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    id="filterProveedor"
                                    label="Proveedor"
                                    name="filterProveedor"
                                    onChange={(event, newValue) => {
                                        setValueFilter('IdProveedor', newValue?.id ?? null)
                                    }}
                                    options={proveedoresFiltro.map(a => { return { label: a.proveedores, id: a.id } })}
                                    renderInput={(params) => <TextField {...params} label="Proveedor" />}
                                >
                                </Autocomplete>                               
                            </Grid>
                            <Grid item xs="12" sm="6" md="3" lg="2">
                                <Autocomplete
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    id="filterEstatus"
                                    label="Estatus"
                                    name="filterEstatus"
                                    onChange={(event, newValue) => {
                                        setValueFilter('IdEstatus', newValue?.id ?? null)
                                    }}
                                    options={estatusFiltro.map(a => { return { label: a.valor, id: a.id } })}
                                    renderInput={(params) => <TextField {...params} label="Estatus" />}
                                >
                                </Autocomplete>
                                {/* <TextField
                                    size="small"
                                    margin="normal"
                                    select
                                    fullWidth
                                    id="filterEstatus"
                                    label="Estatus"
                                    name="filterEstatus"
                                    onChange={(e) => { setValueFilter('IdEstatus', e.target.value) }}
                                >
                                    <MenuItem value={null}><em>seleccionar</em></MenuItem>
                                    <MenuItem value={2} id={2}>Activo</MenuItem>
                                    <MenuItem value={3} id={3}>Inactivo</MenuItem>
                                </TextField> */}
                            </Grid>
                            <Grid item >
                                <Button
                                    variant="contained"
                                    disabled={!modelFilter.IdPerfil && !modelFilter.IdProveedor && !modelFilter.IdEstatus}
                                    onClick={(event) => { clickBuscarUsuarios(event) }}
                                >
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                        <Box sx={{
                            marginBottom: '1rem',
                            marginTop: '0.5rem',
                            width: '100%',
                            '& .tableHeaders': {
                                color: 'primary.main',
                            },
                        }}>
                            <DataGrid
                                getRowId={(row) => row.idUsuario}
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                                autoHeight
                                rows={entitiesActivos}
                                columns={columns}
                                dataSource={entitiesActivos}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[5, 10, 20]}
                                pagination
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                components={{
                                    Toolbar: GridToolbar,
                                    NoRowsOverlay: () => (
                                        <Stack height="100%" alignItems="center" justifyContent="center">
                                            Sin información
                                        </Stack>
                                    ),
                                    NoResultsOverlay: () => (
                                        <Stack height="100%" alignItems="center" justifyContent="center">
                                            Sin información
                                        </Stack>
                                    )
                                }}
                                componentsProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                        csvOptions: { disableToolbarButton: true },
                                        printOptions: { disableToolbarButton: true },
                                    },
                                }}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </div>
            <ModalComponent
                Open={openModal}
                HandleClose={handleClose}
                ClassName={perfilesList.find(a => a.idPerfil == model?.IdPerfil)?.esInterno || model == undefined ? "modal-xl" : "modal-lg"}
                Body={() => (
                    <FormUsuario
                        onClose={handleClose}
                        data={model}
                        onFinish={(resp) => { onFinishFormulario(resp) }}
                        idUsuario={idUsuario}
                    />
                )}
            />
            <DeleteDialog
                Open={showDeleteDialog}
                FieldName="el usuario"
                OnClose={clearDeleteModel}
                OnFinish={() => {
                    _deleteUsuario();
                }}
            />
            <DialogComponent
                Open={showCambioEstatus}
                Message={mensajeCambioEstatus}
                OnClose={() => {
                    setRowCambioEstatus(null)
                    setShowCambioEstatus(false)
                }}
                OnAccept={() => {
                    confirmarCambioEstatus()
                    setShowCambioEstatus(false)
                }}
            />
        </>
    );
}

export default observer(UsersPage);